import type React from 'react';

import { DepartmentPermissionTagInfo } from '@vlabs/monokit/entities/permission-tags';
import { AttachDepartmentPermissionTagsButton, AssignPermissionTagsForAllInDepartmentsSwitch } from '@vlabs/monokit/features';
import { DetachDepartmentPermissionTagsIconButton } from '@vlabs/monokit/features/point/detach-department-permission-tags';
import { useGetDepartment } from '@vlabs/api/artemy/client';
import type { DepartmentId } from '@vlabs/api/artemy/model';

import st from './DepartmentPermissionTagList.module.sass';
import { useDepartmentPermissionTagListTranslation } from './i18n';
import { FoldableEntity } from '../../../shared/ui/foldable-entity';
import type { FoldableEntityProps } from '../../../shared/ui/foldable-entity';

interface DepartmentPermissionTagListProps extends Pick<FoldableEntityProps, 'actions'> {
  departmentId: DepartmentId;
}

function DepartmentPermissionTagList({
  departmentId,
  ...props
}: DepartmentPermissionTagListProps): React.JSX.Element {
  const { t } = useDepartmentPermissionTagListTranslation();
  const getDepartment = useGetDepartment(departmentId);

  return (
    <FoldableEntity
      actions={<AttachDepartmentPermissionTagsButton departmentId={departmentId} />}
      heading={t('title')}
      {...props}
    >
      {getDepartment.data?.permission_tags?.map(({ permission_tag: permissionTag }) => {
        return permissionTag && (
          <DepartmentPermissionTagInfo
            actions={(
              <div className={st.Actions}>
                <AssignPermissionTagsForAllInDepartmentsSwitch
                  departmentId={departmentId}
                  permissionTags={[permissionTag]}
                />
                <DetachDepartmentPermissionTagsIconButton
                  departmentId={departmentId}
                  permissionTags={[permissionTag]}
                />
              </div>
            )}
            key={permissionTag}
            permissionTag={permissionTag}
          />
        );
      })}
    </FoldableEntity>
  );
}

export { DepartmentPermissionTagList };
